import { Stack, Typography } from "@mui/material";
import React from "react";

function SubtypeField({ value }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      alignContent={"center"}
      height={"100%"}
    >
      <Typography sx={{ marginLeft: "12px" }}>{value || "N/A"}</Typography>
    </Stack>
  );
}

function getSubtypeLabel(value) {
  switch (value) {
    case "compound":
      return "Compund";
    case "bundle":
      return "Bundle";
    case "refurbished":
      return "Refurbished";
    default:
      return "N/A";
  }
}

export default SubtypeField;
